// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("../../assets/fonts/GTEestiBold.otf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_1___ = new URL("../../assets/fonts/AvenirBook.otf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_2___ = new URL("../../assets/fonts/AvenirBlack.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_3___ = new URL("../../assets/fonts/AvenirOblique.otf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_4___ = new URL("./assets/delete.webp", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
var ___CSS_LOADER_URL_REPLACEMENT_1___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_1___);
var ___CSS_LOADER_URL_REPLACEMENT_2___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_2___);
var ___CSS_LOADER_URL_REPLACEMENT_3___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_3___);
var ___CSS_LOADER_URL_REPLACEMENT_4___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_4___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/*******************************************************
 *                                                     *
 *                VIAJES TEIDE                         *
 *                                                     *
 *        developed: Javier Vega Martinez              *
 *        contact: info@emdbwebprojects.com            *
 *        copyright - 2014-2024                        *
 *                                                     *
 *******************************************************/
/* width */
/* fonts */
@font-face {
  font-family: GTEestiBold;
  src: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
}
@font-face {
  font-family: AvenirBook;
  src: url(${___CSS_LOADER_URL_REPLACEMENT_1___});
}
@font-face {
  font-family: AvenirBlack;
  src: url(${___CSS_LOADER_URL_REPLACEMENT_2___});
}
@font-face {
  font-family: AvenirOblique;
  src: url(${___CSS_LOADER_URL_REPLACEMENT_3___});
}
/* debug */
.debug-alQiv {
  background-color: #ff7f50;
}
.debug2-ZjnSm {
  background-color: #6495ed;
}
.cart-Enie6 {
  position: relative;
  width: 100%;
  margin: 20px 0px;
  font-family: AvenirBook;
}
.cart-Enie6 .cart-empty-OTjA_ {
  margin: 20px 10px;
  border: 1px solid #333333;
}
.cart-Enie6 h2 {
  font-family: AvenirBlack;
  font-size: 1.125em;
  margin-bottom: 20px;
}
.cart-Enie6 .cartItems-M4WjQ .cartItem-Bv7ZW {
  display: flex;
  gap: 15px;
  width: 100%;
  margin: 0px 0px 20px 0px;
  border-radius: 20px;
  border: 1px solid #E1E1E1;
}
.cart-Enie6 .cartItems-M4WjQ .cartItem-Bv7ZW .photo-aVL3r {
  flex: 3;
  margin: 2% 0px 0px 2%;
}
.cart-Enie6 .cartItems-M4WjQ .cartItem-Bv7ZW .photo-aVL3r img {
  width: 100%;
  border-radius: 10px;
}
.cart-Enie6 .cartItems-M4WjQ .cartItem-Bv7ZW .info-AyTvK {
  flex: 6;
  margin-block: 10px;
}
.cart-Enie6 .cartItems-M4WjQ .cartItem-Bv7ZW .info-AyTvK .title-XwdIt {
  font-family: AvenirBlack;
  font-size: 1.125em;
}
.cart-Enie6 .cartItems-M4WjQ .cartItem-Bv7ZW .info-AyTvK .date-UiYo2 {
  margin-top: 5px;
  font-family: AvenirBook;
  font-size: 1em;
}
.cart-Enie6 .cartItems-M4WjQ .cartItem-Bv7ZW .info-AyTvK .language-pht7m {
  margin-top: 5px;
  font-family: AvenirBook;
  font-size: 1em;
}
.cart-Enie6 .cartItems-M4WjQ .cartItem-Bv7ZW .info-AyTvK b {
  font-family: AvenirBook;
}
.cart-Enie6 .cartItems-M4WjQ .cartItem-Bv7ZW .info-AyTvK .content-isnoJ {
  float: left;
  width: 100%;
  padding-top: 15px;
}
.cart-Enie6 .cartItems-M4WjQ .cartItem-Bv7ZW .info-AyTvK .content-isnoJ .itemPax-CFI3u {
  display: flex;
  height: 40px;
  line-height: 40px;
  font-size: 1em;
}
.cart-Enie6 .cartItems-M4WjQ .cartItem-Bv7ZW .info-AyTvK .content-isnoJ .itemPax-CFI3u .name-bHYtZ {
  flex: 8;
}
.cart-Enie6 .cartItems-M4WjQ .cartItem-Bv7ZW .info-AyTvK .content-isnoJ .itemPax-CFI3u .select-X9qe9 {
  flex: 2;
  text-align: center;
  margin-bottom: 10px;
}
.cart-Enie6 .cartItems-M4WjQ .cartItem-Bv7ZW .info-AyTvK .content-isnoJ .itemPax-CFI3u .select-X9qe9 .selectnumpax-voATN {
  width: 45px;
  height: 35px;
  border-radius: 10px;
  color: #666666;
  border: 2px solid #E1E1E1;
}
.cart-Enie6 .cartItems-M4WjQ .cartItem-Bv7ZW .actions-Rlrxe {
  flex: 2;
  margin: 10px 10px 10px 0px;
  text-align: center;
}
.cart-Enie6 .cartItems-M4WjQ .cartItem-Bv7ZW .actions-Rlrxe .totalprice-e5PYz {
  margin: 30px 0px 0px 0px;
  font-size: 1em;
}
.cart-Enie6 .cartItems-M4WjQ .cartItem-Bv7ZW .actions-Rlrxe .totalprice-e5PYz b {
  font-family: AvenirBook;
}
.cart-Enie6 .cartItems-M4WjQ .cartItem-Bv7ZW .actions-Rlrxe .delete-S7DUv {
  margin: 30px 0px 0px 0px;
  cursor: pointer;
}
.cart-Enie6 .cartItems-M4WjQ .cartItem-Bv7ZW .actions-Rlrxe .delete-S7DUv .deleteicon-MTGVu {
  width: 26px;
  height: 26px;
  margin-inline: auto;
  background: url(${___CSS_LOADER_URL_REPLACEMENT_4___}) 0px 0px;
}
.cart-Enie6 .cartItems-M4WjQ .cartItem-Bv7ZW .actions-Rlrxe .delete-S7DUv .text-Lb8oz {
  margin: 5px 0px 0px 0px;
}
`, "",{"version":3,"sources":["webpack://./src/components/VTCart/VTCart.module.less","webpack://./src/assets/css/theme.less"],"names":[],"mappings":"AAAA;;;;;;;;wDAQwD;AACxD,UAAU;AACV,UAAU;ACwBV;EAAY,wBAAA;EAA0B,4CAAA;ADpBtC;ACqBA;EAAY,uBAAA;EAAyB,4CAAA;ADjBrC;ACkBA;EAAY,wBAAA;EAA0B,4CAAA;ADdtC;ACeA;EAAY,0BAAA;EAA4B,4CAAA;ADXxC;AACA,UAAU;ACiBV;EAAQ,yBAAA;ADdR;ACeA;EAAS,yBAAA;ADZT;AA/BA;EAAM,kBAAA;EAAmB,WAAA;EAAY,gBAAA;EAAkB,uBAAA;AAqCvD;AArCA;EAEc,iBAAA;EAAmB,yBAAA;AAuCjC;AAzCA;EAGK,wBAAA;ECmCH,kBAAA;EDnC4C,mBAAA;AA2C9C;AA9CA;EAMc,aAAA;EAAc,SAAA;EAAU,WAAA;EAAY,wBAAA;EAA2B,mBAAA;EAAqB,yBAAA;AAgDlG;AAtDA;EAOa,OAAA;EAAQ,qBAAA;AAmDrB;AA1DA;EAQY,WAAA;EAAa,mBAAA;AAsDzB;AA9DA;EAUY,OAAA;EAAQ,kBAAA;AAwDpB;AAlEA;EAWe,wBAAA;EC2Bb,kBAAA;ADgCF;AAtEA;EAYc,eAAA;EAAiB,uBAAA;EC0B7B,cAAA;ADqCF;AA3EA;EAakB,eAAA;EAAiB,uBAAA;ECyBjC,cAAA;AD0CF;AAhFA;EAcU,uBAAA;AAqEV;AAnFA;EAgBiB,WAAA;EAAY,WAAA;EAAY,iBAAA;AAwEzC;AAxFA;EAiBmB,aAAA;EAAc,YAAA;EAAc,iBAAA;ECqB7C,cAAA;ADwDF;AA9FA;EAkBkB,OAAA;AA+ElB;AAjGA;EAmBoB,OAAA;EAAQ,kBAAA;EAAoB,mBAAA;AAmFhD;AAtGA;EAoB4B,WAAA;EAAY,YAAA;EAAa,mBAAA;EAAqB,cAAA;EAAmB,yBAAA;AAyF7F;AA7GA;EAyBe,OAAA;EAAQ,0BAAA;EAA4B,kBAAA;AAyFnD;AAlHA;EA0BoB,wBAAA;ECYlB,cAAA;ADgFF;AAtHA;EA2BY,uBAAA;AA8FZ;AAzHA;EA6BgB,wBAAA;EAA0B,eAAA;AAgG1C;AA7HA;EA8BsB,WAAA;EAAa,YAAA;EAAc,mBAAA;EAAoB,2DAAA;AAqGrE;AAnIA;EA+BgB,uBAAA;AAuGhB","sourcesContent":["@import \"../../assets/css/theme\";\n\n.cart{position:relative; width:100%; margin: 20px 0px; font-family:AvenirBook;\n\n  .cart-empty{margin: 20px 10px; border: 1px solid @colorgris4;}\n  h2{font-family:AvenirBlack; .font-base(18); margin-bottom: 20px;}\n\n  .cartItems{\n    .cartItem{display:flex; gap:15px; width:100%; margin: 0px 0px 20px 0px;  border-radius: 20px; border: 1px solid @colorgris1;\n      .photo{flex:3; margin: 2% 0px 0px 2%;\n        img{width: 100%; border-radius: 10px;}\n      }\n      .info{flex:6; margin-block:10px;\n        .title{font-family:AvenirBlack; .font-base(18);}\n        .date{margin-top: 5px; font-family:AvenirBook; .font-base(16);}\n        .language{margin-top: 5px; font-family:AvenirBook; .font-base(16);}\n        b{font-family:AvenirBook;}\n\n        .content{float:left; width:100%; padding-top: 15px;\n          .itemPax{display:flex; height: 40px; line-height: 40px; .font-base(16);\n            .name{flex:8; }\n            .select{flex:2; text-align: center; margin-bottom: 10px;\n              .selectnumpax{width:45px; height:35px; border-radius: 10px; color:@colorgris3; border: 2px solid @colorgris1;}\n            }\n          }\n        }\n      }\n      .actions{flex:2; margin: 10px 10px 10px 0px; text-align: center;\n        .totalprice{margin: 30px 0px 0px 0px; .font-base(16);\n          b{font-family:AvenirBook;}\n        }\n        .delete{margin: 30px 0px 0px 0px; cursor: pointer;\n          .deleteicon{width: 26px; height: 26px; margin-inline:auto; background: url(\"./assets/delete.webp\") -0px -0px;}\n          .text{margin: 5px 0px 0px 0px; }\n        }\n      }\n    }\n  }\n}\n\n\n\n","/*******************************************************\n *                                                     *\n *                VIAJES TEIDE                         *\n *                                                     *\n *        developed: Javier Vega Martinez              *\n *        contact: info@emdbwebprojects.com            *\n *        copyright - 2014-2024                        *\n *                                                     *\n *******************************************************/\n\n//VARS\n\n@colorverde1: #99CC33;  //verde 1\n@colorverde2: #009933;  //verde 2\n@colorverde3: #BEE266;  //verde 3\n@colorazul1: #33CCFF;   //azul 1\n@colorrosa1: #FF6698;   //rosa 1\n\n@colorgris1: #E1E1E1;   //Gris background footer\n@colorgris2: #999999;   //Gris text\n@colorgris3: #666666;   //Gris text\n@colorgris4: #333333;   //Gris text\n@colorgris5: #5D5D5D;\n\n/* width */\n@width-space:20px;\n@width-column:40px;\n@width-content: 1100px;\n@width-total: @width-content + 20px;\n@width-min:400px;\n\n/* fonts */\n@em:16px;\n\n@font-face {font-family: GTEestiBold; src: url('../fonts/GTEestiBold.otf'); }\n@font-face {font-family: AvenirBook; src: url('../fonts/AvenirBook.otf'); }\n@font-face {font-family: AvenirBlack; src: url('../fonts/AvenirBlack.ttf'); }\n@font-face {font-family: AvenirOblique; src: url('../fonts/AvenirOblique.otf'); }\n\n.font-base(@sizeValue) {\n  font-size: unit(( @sizeValue / @em ), em);\n}\n\n/* debug */\n.debug {background-color:#ff7f50;}\n.debug2 {background-color:#6495ed ;}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"debug": `debug-alQiv`,
	"debug2": `debug2-ZjnSm`,
	"cart": `cart-Enie6`,
	"cart-empty": `cart-empty-OTjA_`,
	"cartItems": `cartItems-M4WjQ`,
	"cartItem": `cartItem-Bv7ZW`,
	"photo": `photo-aVL3r`,
	"info": `info-AyTvK`,
	"title": `title-XwdIt`,
	"date": `date-UiYo2`,
	"language": `language-pht7m`,
	"content": `content-isnoJ`,
	"itemPax": `itemPax-CFI3u`,
	"name": `name-bHYtZ`,
	"select": `select-X9qe9`,
	"selectnumpax": `selectnumpax-voATN`,
	"actions": `actions-Rlrxe`,
	"totalprice": `totalprice-e5PYz`,
	"delete": `delete-S7DUv`,
	"deleteicon": `deleteicon-MTGVu`,
	"text": `text-Lb8oz`
};
export default ___CSS_LOADER_EXPORT___;
